import _ from 'lodash';
import { action, makeAutoObservable, makeObservable, observable, runInAction } from 'mobx';

export type ToastType = 'default' | 'success' | 'error' | 'info';

export type ToastItem = {
    id: string;
    message: string;
    type: ToastType;
    state: 'ready' | 'hiding' | 'hidden';
};

class ToastStore {
    toasts: Map<string, ToastItem> = new Map();

    constructor() {
        makeObservable(this, {
            toasts: observable,

            show: action,
        });
    }

    show(
        message: string,
        {
            type = 'default',
            duration = 2500,
        }: {
            type?: ToastType;
            duration?: number;
        },
    ) {
        const id = _.uniqueId('toast_');
        const toast: ToastItem = {
            type: type || 'default',
            id,
            message,
            state: 'ready',
        };

        this.toasts.set(id, toast);

        // duration 후 hiding 상태로 변경
        _.delay(() => {
            runInAction(() => {
                this.toasts.get(id)!.state = 'hiding';

                // 애니메이션 후 제거 (duration + 300ms)
                _.delay(() => {
                    runInAction(() => {
                        this.toasts.get(id)!.state = 'hidden';
                    });
                }, 300);
            });
        }, duration);
    }

    success(message: string, duration?: number) {
        this.show(message, { type: 'success', duration });
    }

    error(message: string, duration?: number) {
        this.show(message, { type: 'error', duration });
    }

    info(message: string, duration?: number) {
        this.show(message, { type: 'info', duration });
    }
}

export default new ToastStore();
